// Import Cores
import axios from 'axios';
import VuexORM from '@vuex-orm/core';
import VuexORMSearch from '@vuex-orm/plugin-search';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import Auth from '@/models/Auth';
import { useAuth } from '@/composables/useAuth';
import appConfig from '@/configs/app-config';

const { handleErrorInvalidToken } = useAuth();

export const vuexOrmPlugin = {
  register(axiosConfig = {}) {
    const database = new VuexORM.Database();

    VuexORM.use(VuexORMSearch);

    const ormAxios = axios.create(axiosConfig);

    let attempts = 0;

    ormAxios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (attempts >= appConfig.auth.retry.limit) {
          console.log('[vuex-orm.js] retry limit reached:', attempts);

          attempts = 0;

          return Promise.reject(error);
        }

        try {
          // Only unauthirized error will be handled, other errors will be rejected
          await handleErrorInvalidToken(error);

          const config = error.config;

          config.headers.Authorization = `Bearer ${Auth.getAppToken()}`;

          attempts++;

          return ormAxios(config);
        } catch (error) {
          return Promise.reject(error);
        }
      }
    );

    VuexORM.use(VuexORMAxios, {
      axios: ormAxios
    });

    return { plugin: VuexORM.install(database), database, axios: ormAxios };
  }
};
